export const FORM_NAMES = {
  ADDRESS: 'address',
};

export const PIN_LENGTH = 6;
